import { FormEvent, useCallback, useState } from "react";
import Input from "@avinet/adaptive-ui-core/form/controls/Input";
import FormProvider from "@avinet/adaptive-ui-core/form/FormProvider";
import useForm from "@avinet/adaptive-ui-core/form/useForm";
import { useTranslate } from "@avinet/adaptive-ui-translate";
import { UserApi } from "../../api/UserApi";
import useSessionToken from "../../hooks/useSessionToken";
import { Dialog } from "./Dialog";
import "./DeleteUserDialog.scss";

interface DeleteUserDialogProps {
  onClose: () => void;
}

export function DeleteUserDialog({ onClose }: DeleteUserDialogProps) {
  const t = useTranslate("DeleteUserDialog");
  const { form, state } = useForm({
    langSet: "DeleteUserDialog",
  });
  const [isSaving, setSaving] = useState(false);
  const [showButtons, setShowButtons] = useState(true);
  const [desc, setDescription] = useState(t("description"));
  const [error, setError] = useState<Error>();
  const sessionToken = useSessionToken();

  const handleSubmit = useCallback(
    async (e: FormEvent<HTMLFormElement>) => {
      e.preventDefault();
      setError(undefined);
      setSaving(true);

      const [success, result] = await UserApi.delete("me", sessionToken);
      if (success) {
        // onClose();
        setShowButtons(false);
        setDescription(t("deleted_description"));
        localStorage.clear();
      } else setError(result);
      setSaving(false);
    },
    [onClose, sessionToken]
  );

  return (
    <Dialog
      className="delete"
      title={t("title")}
      buttons={
        <>
          {showButtons && (
            <button type="button" className="btn light" onClick={onClose}>
              {t("cancel")}
            </button>
          )}
          {showButtons && (
            <button type="submit" className="btn primary">
              {t("submitLabel")}
            </button>
          )}
        </>
      }
      icon="person"
      onSubmit={handleSubmit}
      //onClose={onClose}
      // mask={isSaving}
    >
      <FormProvider form={form} state={state}>
        <p id="message">{desc}</p>
        {error && (
          <p className="error">{t("saveError", { error: error.message })}</p>
        )}
      </FormProvider>
    </Dialog>
  );
}
